function matchRefSamples(refSamples, keys) {
  // some samples names might contain spaces
  if (typeof refSamples === "string") {
    return keys.filter((x) => ` ${refSamples} `.indexOf(` ${x} `) > -1);
  }
  return Array.isArray(refSamples) ? refSamples : [];
}

function getName(sample = {}) {
  return sample.user_sample || sample.sample;
}

function normalizeSample(sample, allNames, nameToId) {
  const refSamples = matchRefSamples(sample.refSamples, allNames);
  const refSampleIds = refSamples.map((x) => String(nameToId[x]));

  return {
    id: String(sample.sampleId),
    name: sample.user_sample || sample.sample,
    refSampleNames: refSamples,
    refSampleIds,
    refSampleIdSet: new Set(refSampleIds),
    isRestricted: sample?.is_restricted ?? false,
  };
}

function parseQcReport(data = []) {
  const res = data.filter((x) => x && x.sampleId);
  const nToId = res.reduce((a, i) => ({ ...a, [getName(i)]: i.sampleId }), {});
  const sampleNames = res.map((x) => x.user_sample || x.sample);
  const samples = res.map((x) => normalizeSample(x, sampleNames, nToId));
  const sampleIdMap = samples.reduce((a, i) => ({ ...a, [i.id]: i }), {});
  const sampleNameMap = samples.reduce((a, i) => ({ ...a, [i.name]: i }), {});
  return { sampleIdMap, sampleNameMap, samples };
}

export default parseQcReport;
